// React imports
import React, { useEffect, useState } from 'react';

// Third-party library imports
import { Hub } from 'aws-amplify/utils';
import { get } from 'lodash-es';

// Local imports - Custom hooks
import { HubListenningContext } from './HubListenningContext';

interface IHubListenningProviderProps {
	children?: React.ReactNode;
}
export const HubListenningProvider = ({ children }: IHubListenningProviderProps) => {
	const [authState, setAuthState] = useState('');
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		const unsubscribeHub = Hub.listen('auth', ({ payload }) => {
			setAuthState(payload.event);
			const message = get(payload, 'data.error.message', '');
			if (message) {
                setErrorMessage(message);
            }
		});

		return unsubscribeHub;
	}, []);
	
	return (
		<HubListenningContext.Provider value={{ listenedAuth: authState, listenedAuthError: errorMessage }}>
		  {children}
		</HubListenningContext.Provider>
	);
};